import { changeIntegrationTranslations } from 'actions/integrationSettings';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getIntegrationSettingsForm } from 'selectors/integrationSettings';
import { useSelector } from 'store';

const TranslationsNeeded: React.FC = () => {
  const dispatch = useDispatch();

  const { translations_needed: translations } = useSelector(getIntegrationSettingsForm);

  const handleTranslationsChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    dispatch(changeIntegrationTranslations(e.target.value === 'true'));
  };

  return (
    <div className="flex flex-col gap-2">
      <div>
        <span>Translations needed?</span>
        <span className="litlingo-red-color">*</span>
      </div>

      <div>
        <div className="flex flex-col gap-2">
          <label htmlFor="translations-yes" className="flex justify-start items-center w-22">
            <input
              type="radio"
              id="translations-yes"
              name="translations"
              value="true"
              onChange={handleTranslationsChange}
              checked={translations === true}
              className="input-radio"
            />
            <span className="text ml-1">Yes</span>
          </label>
          <label htmlFor="translations-no" className="flex justify-start items-center w-22">
            <input
              type="radio"
              id="translations-no"
              name="translations"
              value="false"
              onChange={handleTranslationsChange}
              checked={translations === false}
              className="input-radio"
            />
            <span className="text ml-1">No</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default TranslationsNeeded;
